
import { reactive } from 'vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'
import Loader from '@/components/elements/Loader.vue'

export default {
  name: 'MypageCheckin',

  components: {
    HeadingLv1,
    Loader
  },

  props: {
    eventData: {
      type: Object,
      default: () => ({})
    }
  },

  beforeRouteEnter: async (to: any, from: any, next: any) => {
    const getEventInfo = axiosSetting('cms', 'page')

    const result = await getEventInfo
      .get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/mynaviresident/v1/event/checkin?checkin_id=${to.params.id}`
      )
      .then((res) => {
        return res.data
      })
      .catch(() => {
        return 'error'
      })

    if (result === 'error') return next('/404')

    to.matched[0].props.default = {
      eventData: result
    }

    next()
  },

  setup(props: any) {
    const store = useStore()
    const state = reactive({
      isLoading: true,
      isSuccess: false,
      isCheckInError: false
    })

    const getTitle = (checkinType: string) => {
      if (checkinType === 'E') return 'イベント来場受付'
      return 'ブースチェックイン'
    }
    const getDate = () => {
      const week = ['日', '月', '火', '水', '木', '金', '土']
      const now = new Date()
      let date = now.getFullYear() + '年'
      date += now.getMonth() + 1 + '月'
      date += now.getDate() + '日'
      date += '(' + week[now.getDay()] + ')'

      return date
    }

    const title = getTitle(props.eventData.applicant_type)
    const date = getDate()

    const tryCheckin = () => {
      interface Params {
        event_id: number
        holding_type: number
        data: {
          applicant_type: string
          hospital_id?: string
          program_id?: string
        }[]
      }
      const params: Params = {
        event_id: props.eventData.event_id,
        holding_type: props.eventData.holding_type,
        data: [
          {
            applicant_type: props.eventData.applicant_type
          }
        ]
      }
      if (props.eventData.applicant_type === 'EH') {
        const data = [
          {
            applicant_type: props.eventData.applicant_type,
            hospital_id: props.eventData.hospital_id,
            program_id: props.eventData.program_id
          }
        ]
        params.data = data
      }
      const postCheckinInfo = axiosSetting('app', 'page')

      postCheckinInfo
        .post(`/api/v1/check_in`, params)
        .then(() => {
          state.isSuccess = true
        })
        .catch((err) => {
          try {
            if (err.response.status === 422) {
              const errors = err.response.data.err_msg

              Object.keys(errors).forEach((key: string) => {
                alert(errors[key][0])
              })
              return
            }
            if (err.response.status === 504) {
              state.isCheckInError = true
              return
            }

            store.commit('showSystemError', 'modal')
          } catch (e) {
            store.commit('showSystemError', 'modal')
          }
        })
        .then(() => {
          state.isLoading = false
        })
    }
    tryCheckin()

    return {
      state,
      title,
      date
    }
  }
}
